<template>
    <div>
      <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
      </v-overlay>
      <div v-if="!loading">
        <app-form
            v-bind:parentObject="{
            data: this.formData[0],
            searchnew: this.search,
            pageTitle: this.pageTitle,
            pageTitleValue: this.pageTitleValue,
            errMsg: this.errMsg,
            isEdit: this.editMode,
            }"
            v-on:input="formData[0] = $event"
            v-on:save="saveHandler"
            v-on:error="errorHandler"
        />

        <div v-if="isErr">
            <app-error
            v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
            />
        </div>
        </div>
    </div>
</template>

<script>
import WorkflowForm from "../../../components/settings/workflow/Form.vue";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": WorkflowForm,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            id: this.$route.params.id,
            search: this.$route.params.search,
            pageTitle: this.$t('workflowrole.editworkflowrole'),
            pageTitleValue: "",
            formData: [],
            errMsg: "",
            isErr: false,
            loading: true,
            editMode: false,
            isConfirm: false,
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        saveHandler() {
            
            const vm = this;

            // if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
            //     return false;
            // }

            this.formData[0].systemrole = this.formData[0].systemrole ? 1 : 0;
            this.formData[0].isdisable = this.formData[0].isdisable ? 1 : 0;
            this.formData[0].userid = this.$store.getters.userId;

            var payload = this.formData[0];

            this.$store.dispatch('put', {url: "/workflowrole/" + vm.id, payload: payload})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = res.data.error;
                } else {
                    this.$router.push({ name: "wfrolelist", params: { search: this.search} });
                }
            })
            .catch((err) => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });

        },

        loadWorkflowHandler() {

            const vm = this;

            return this.$store.dispatch('get', {url: "/workflowrole/" + vm.id})
            .then((res) => {

            if (res.status == 200) {
                
                vm.formData = res.data.rec;

                vm.pageTitleValue = vm.formData[0].role;

                vm.formData[0].systemrole = vm.formData[0].systemrole === 1 ? true : false;
                vm.formData[0].isdisable = vm.formData[0].isdisable === 1 ? true : false;

                vm.loading = false;

            } else {
                vm.isErr = !vm.isErr;
            }
            })
            .catch((err) => {
                console.log(err);
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },

    },

    async mounted() {
        await this.loadWorkflowHandler();
    },
};
</script>